var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('img',{attrs:{"alt":"Vue logo","src":require("../assets/logo.png")}}),_c('h2',[_vm._v("name: "+_vm._s(_vm.name))]),_c('HelloWorld',{attrs:{"msg":"Welcome to view project hel-tpl-remote-vue-comp ( from unpkg deploy )"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }